import api from 'api';

export const MENU_ITEM_COST_ASYNC_ACTION_START = 'MENU_ITEM_COST_ASYNC_ACTION_START';
export const MENU_ITEM_COST_ASYNC_ACTION_ERROR = 'MENU_ITEM_COST_ASYNC_ACTION_ERROR';
export const MENU_ITEM_COST_ASYNC_ACTION_UPDATE_SUCCESS = 'MENU_ITEM_COST_ASYNC_ACTION_UPDATE_SUCCESS';
export const MENU_ITEM_COST_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_COST_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_COST_RESET_STATE = 'MENU_ITEM_COST_RESET_STATE';

function menuItemCostAsyncActionStart() {
  return {
    type: MENU_ITEM_COST_ASYNC_ACTION_START,
  };
}

function menuItemCostAsyncActionError(error) {
  return {
    type: MENU_ITEM_COST_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemCostAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_COST_ASYNC_ACTION_UPDATE_SUCCESS,
    data,
  };
}

export function updateMenuItemCost(data) {
  return {
    type: MENU_ITEM_COST_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetMenuItemCostState() {
  return {
    type: MENU_ITEM_COST_RESET_STATE,
  };
}

export function updateMenuItemCostAsync(menuItemCost) {
  return (dispatch, getState) => {
    dispatch(menuItemCostAsyncActionStart());
    return api.request('menuItemCost/menuItem', 'put', menuItemCost)
    .then((data) => {
      dispatch(menuItemCostAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemCostAsyncActionError('Unable to update menu item cost'));
      throw (err);
    });
  };
}
